import React from "react"
import { twMerge } from "tailwind-merge"

const APPLE_STORE_LINKS = {
  store: "https://apps.apple.com/app/aldoo-books-music/id6446379455",
  kids: "https://apps.apple.com/us/app/aldoo-kids-preschool-games/id1550787199",
}
const GOOGLE_PLAY_LINKS = {
  store: "https://play.google.com/store/apps/details?id=com.aldoo.books&hl=en&gl=US",
  kids: "https://play.google.com/store/apps/details?id=com.rilagames.patandtom&hl=en&gl=US",
}

const sizes = { small: 100, medium: 120, normal: 150 }

export function AppleStoreButton({ width = 184, app = "store" }) {
  return (
    <a href={APPLE_STORE_LINKS[app]} target="_blank" rel="noopener noreferrer" className="inline-block">
      <picture>
        <source srcSet="/static/p-images/app_store--368x109.webp" type="image/webp" />
        <img src="/static/p-images/app_store--368x109.jpg" alt="App Store" style={{ width }} loading="lazy" />
      </picture>
    </a>
  )
}

export function GoogleStoreButton({ width = 184, app = "store" }) {
  return (
    <a href={GOOGLE_PLAY_LINKS[app]} target="_blank" rel="noopener noreferrer" className="inline-block">
      <picture>
        <source srcSet="/static/p-images/google_play--367x109.webp" type="image/webp" />
        <img src="/static/p-images/google_play--367x109.jpg" alt="Google Play" style={{ width }} loading="lazy" />
      </picture>
    </a>
  )
}

export default function AppsIcons({ size = "normal", app = "store", className = "" }) {
  const width = sizes[size] ?? sizes.normal
  return (
    <div className={twMerge("flex flex-row gap-[18px] items-center", className)}>
      <AppleStoreButton width={width} app={app} />
      <GoogleStoreButton width={width} app={app} />
    </div>
  )
}
